import type {CSSProperties, ReactNode} from 'react';
import {cn} from '@chekinapp/ui';

type Props = {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

function VelaTip({icon, title, description, className, style}: Props) {
  return (
    <div className={cn('flex gap-[11px] py-[11px]', className)} style={style}>
      {icon && (
        <span className="grid h-[30px] w-[30px] flex-none place-items-center rounded-[9px] bg-[var(--assistant-tip-icon-bg)] text-[var(--assistant-tip-icon)] [&_svg]:h-4 [&_svg]:w-4">
          {icon}
        </span>
      )}
      <div className="min-w-0 flex-1">
        <strong className="block text-[13px] font-bold text-[var(--assistant-tip-title)]">
          {title}
        </strong>
        {description && (
          <span className="mt-0.5 block text-[12px] leading-[17px] text-[var(--assistant-tip-description)]">
            {description}
          </span>
        )}
      </div>
    </div>
  );
}

export {VelaTip};
